module.exports = __webpack_public_path__ + "static/img/photo-04.a5ba9ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides_photo/photo-04.jpg
// module id = 8+rT
// module chunks = 0